import { MobileMeterType, MobileMeterTypeModel } from 'common';
import { HttpService } from './http.service';
import { UtilityFamily, MeterManufacturerModel, UtilityTypeIds } from '@ncss/models/dist/v3';

export class MeterTypeService extends HttpService {
  getUsedMeterTypes(propertyId: string, utilityTypeId?: UtilityTypeIds | null): Promise<MobileMeterType[]> {
    return this.send<MobileMeterTypeModel[]>({
      method: 'get',
      url: `/Properties/${propertyId}/MeterTypes`,
      query: utilityTypeId ? { utilityTypeId } : undefined,
    }).then((docs) => docs.map((d) => new MobileMeterType(d)));
  }

  getManufacturers(utilityFamily: UtilityFamily) {
    return this.send<MeterManufacturerModel[]>({
      method: 'get',
      url: `/MeterManufacturers/${utilityFamily}`,
    });
  }

  getMeterTypes(manufacturerId: number, utilityFamily: UtilityFamily) {
    return this.send<MobileMeterType[]>({
      method: 'get',
      url: `/MeterManufacturers/${manufacturerId}/Models/${utilityFamily}`,
    }).then((docs) => docs.map((d) => new MobileMeterType(d)));
  }
}
